module.exports = __webpack_public_path__ + "img/icon17.662872bb.svg";